import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, User } from 'lucide-react';
import DarkModeToggle from './DarkModeToggle';

/**
 * Uniform Dashboard Header Component
 * Used across all learner pages (Home, Study, Progress, Community, Challenges, Pinup)
 */
const DashboardHeader = ({ title, isSidebarCollapsed }) => {
  return (
    <div 
      className="bg-[#AC5757] rounded-l-lg" 
      style={{ 
        marginLeft: isSidebarCollapsed ? '90px' : `calc(14vw + 10px)`,
        transition: 'margin-left 0.3s ease'
      }}
    >
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex-1">
          <h1 className="font-oswald font-medium text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[65px]">
            {title}
          </h1>
        </div>
        
        <div className="flex items-center gap-3">
          {/* Dark Mode Toggle */}
          <DarkModeToggle size="small" />
          
          {/* Messages Icon */}
          <Link 
            to="/app/messages" 
            className="p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            <MessageSquare size={24} className="text-white" />
          </Link>
          
          {/* Profile */}
          <Link 
            to="/app/profile" 
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
          >
            <User size={20} className="text-white" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
